import React from 'react';
import { Modal } from 'react-bootstrap';

import { useGetSlotSegmentsQuery } from '../../../redux/globalOverview';
import SplitShiftSegmentsTable from './SplitShiftSegmentsTable';
import CloseIcon from '../../../assets/images/close.svg';

import './SplitShiftDetailsModal.scss';

/**
 * Mobile counterpart of SplitShiftDetailsOverlay - touch has no hover, so the split shift chip opens
 * this modal on click instead. Mounted only while open, so every open fetches fresh segments.
 * @param {number} slotId - slot whose segments are shown
 * @param {number} managementCompanyId - management company of the slot's facility
 * @param {number} segmentsCount - expected number of segments, used to size the loading skeleton
 * @param {Function} onClose - called by the header X, the footer button and the backdrop
 * @returns {JSX.Element}
 */
const SplitShiftDetailsModal = ({ slotId, managementCompanyId, segmentsCount, onClose }) => {
	const { data: segments = [], isFetching } = useGetSlotSegmentsQuery(
		{ slotId, managementCompanyId },
		{ refetchOnMountOrArgChange: true }
	);

	// The split was reverted after this row was rendered, so there is nothing to show.
	const hasNoSegments = !isFetching && segments.length === 0;

	return (
		<Modal show centered onHide={onClose} className="split-shift-details-modal">
			<Modal.Header>
				<Modal.Title>Split shift details</Modal.Title>
				<button type="button" className="split-shift-details-modal__close" onClick={onClose}>
					<img src={CloseIcon} alt="Close" />
				</button>
			</Modal.Header>
			<Modal.Body>
				<SplitShiftSegmentsTable
					segments={segments}
					isFetching={isFetching}
					segmentsCount={segmentsCount}
					hasNoSegments={hasNoSegments}
				/>
			</Modal.Body>
			<Modal.Footer>
				<button type="button" className="btn-light" onClick={onClose}>
					Close
				</button>
			</Modal.Footer>
		</Modal>
	);
};

export default SplitShiftDetailsModal;
